// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__VSf7d","menu_button":"style_menu_button__MgROB"};